var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.88945 5.50875c-1.0356.82693-1.20475 2.33681-.37782 3.3724a2.397 2.397 0 00.01146.01424l12.2507 15.10455-12.25067 15.10452c-.83483 1.0293-.67718 2.54048.35212 3.3753a2.39993 2.39993 0 00.0142.01143c1.04583.83514 2.5695.67033 3.41256-.36913l13.6762-16.86229c.59557-.7343.59557-1.78535 0-2.51966L19.30198 5.8779c-.84305-1.03945-2.3667-1.20427-3.41253-.36916z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/icons/right-arrow.svg";
export { SvgRightArrow as ReactComponent };